module.exports = __webpack_public_path__ + "img/blackCard.e026aa7c.svg";